import useSimulationQuery from 'Hooks/query-hooks/simulations/useSimulationQuery';
import useSimulationCountQuery from 'Hooks/query-hooks/simulations//useSimulationCountQuery';
import { useAuthenticationStore } from 'Hooks/zustand/useAuthenticationStore';
import { PIPELINE_ID_SESSION_KEY } from 'Utils';
import useCubeReportQuery from '../reports/useCubeReportQuery';

const getCustomerSimulationId = (simulationId: string, customerId?: string) => {
    if (!simulationId) {
        return '';
    }

    const pipelineId = sessionStorage.getItem(PIPELINE_ID_SESSION_KEY)?.toLowerCase();

    if (pipelineId && pipelineId.toLowerCase() !== 'default') {
        // if the pipelineId is default, this tenant has V1 transactions.
        // in that case, the prefix to simulationId willbe the customerId.
        return `${pipelineId}-${simulationId}`;
    }

    return `${customerId?.toLowerCase()}-${simulationId}`;
};

const useCubeSimulationQuery = (simulationId: string, formValues: any) => {
    const customerId = useAuthenticationStore().userInfo?.customerId;
    const customerSimulationId = getCustomerSimulationId(simulationId, customerId);
    const { countQuery } = useSimulationCountQuery(customerSimulationId) || {};
    const { query } = useSimulationQuery(customerSimulationId) || {};
    const countResult = useCubeReportQuery(formValues, countQuery);
    const { resultSet, isLoading } = useCubeReportQuery(formValues, query);

    const queryResultdata = {
        countResult,
        resultSet,
        isLoading: isLoading || countResult.isLoading
    };

    return queryResultdata || {};
};
export default useCubeSimulationQuery;
